function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.43765 14.6147C7.0709 14.6147 8.15648 15.1835 8.6357 15.5046C8.80196 15.5963 9.31051 15.8716 9.41809 15.8807V2.00917C8.7824 0.899083 6.90465 0 4.96822 0C2.53301 0 0.459658 1.3211 0 2.21101V15.1651C0 15.7706 0.371638 16 0.841076 16C1.20293 16 1.45721 15.8807 1.69193 15.6972C2.26895 15.211 3.62836 14.6147 5.43765 14.6147ZM14.5623 14.6147C16.3814 14.6147 17.7213 15.211 18.3179 15.6972C18.5428 15.8716 18.7873 16 19.1491 16C19.6186 16 20 15.7706 20 15.1651V2.21101C19.5403 1.3211 17.467 0 15.0318 0C13.0954 0 11.2176 0.899083 10.5917 2.00917V15.8991C10.6993 15.8899 11.198 15.6055 11.3741 15.5046C11.8533 15.1835 12.9389 14.6147 14.5623 14.6147Z",
  fill: "#908CA0"
});

function SvgIconContentNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContentNav);
export default __webpack_public_path__ + "static/media/icon-content-nav.e3a33e5e.svg";
export { ForwardRef as ReactComponent };